import { Injectable } from '@angular/core';
import { Modal } from 'bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ModalCleanupService {
  private listenerRegistered = false;

  registerGlobalCleanup(): void {
    if (this.listenerRegistered) return;

    document.addEventListener('hidden.bs.modal', () => {
      this.cleanupWhenNoModalIsOpen();
    });

    this.listenerRegistered = true;
  }

  hideById(id: string): void {
    const el = document.getElementById(id);
    if (!el) {
      this.cleanupWhenNoModalIsOpen();
      return;
    }

    const modal = Modal.getOrCreateInstance(el);
    modal.hide();

    window.setTimeout(() => this.cleanupWhenNoModalIsOpen(), 250);
  }

  cleanupWhenNoModalIsOpen(): void {
    window.setTimeout(() => {
      if (document.querySelector('.modal.show')) return;

      document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove());
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
    });
  }
}
